// R35 (scan 6): reset and setup links carry their one-time code in the URL fragment (as the email
// undo link does), which browsers never send to a server, CDN or Referer. Links mailed before R35
// (?code= or /setup-password/<token>) still work. The code is removed from the address bar and history.
export function takeLinkCode(view, name, fallback) {
  const hash = new URLSearchParams(String(view.location.hash || "").replace(/^#/, ""));
  const query = new URLSearchParams(view.location.search || "");
  const code = hash.get(name) || query.get(name) || fallback || null;
  if (hash.has(name) || query.has(name)) view.history?.replaceState(null, "", view.location.pathname);
  return code;
}
